<list-view *ngIf="listePerimetres" [liste]="listePerimetres"></list-view>
